// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1f4Z7","requiredAsterisk":"Info_requiredAsterisk__X4Uly"};